module.exports = __webpack_public_path__ + "img/error-page.3d16dbf5.svg";